/*
 * File: OrderNoteModel.js
 * Project: mp-mobile-app
 *
 * Created by Jennifer Loecker on 08/21/2019
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Describes an order note type as it comes from the API
 *
 */

import { types } from "mobx-state-tree";

const OrderNote = types.model("OrderNoteModel", {
  assignedToFirst: types.maybe(types.string),
  assignedToLast: types.maybe(types.string),
  assignedToUniqueId: types.maybe(types.string),
  authorFirst: types.maybe(types.string),
  authorLast: types.maybe(types.string),
  authorUniqueId: types.maybe(types.string),
  created: types.maybeNull(types.Date),
  message: types.maybe(types.string)
});

export default OrderNote;
